export { LogoMark } from './logo-mark'
